import { useQuery } from '@tanstack/react-query';
import { MarketGroupCategory } from '../components/molecules/MarketGroupCategories';
import { QUERY_KEYS } from '../constants';
import { getData } from '../utils/api';
import { MarketGroupUsedFor } from '../@types';

export const useMarketCategories = (enableMarketGroups: boolean, usedFor: MarketGroupUsedFor, sportId?: string) => {
  return useQuery({
    queryKey: [QUERY_KEYS.marketGroupCategories, sportId, usedFor],
    queryFn: (): Promise<{ items: MarketGroupCategory[] }> =>
      getData('/market-type-group-categories/client', { usedFor: [usedFor], sportId }),
    enabled: !!sportId && enableMarketGroups,
    select: (data) => data.items,
    staleTime: 5 * 60 * 1000,
  });
};
